import React from 'react';
import Badge from 'react-bootstrap/Badge';

function DatatableReturn(props) {
    const getReturnStatusBadge = (status, stageText) => {
        const s = String(status);
        switch (s) {
            case '1':
                return <Badge bg="primary">{stageText || 'Requested'}</Badge>;
            case '2':
                return <Badge bg="info">{stageText || 'Approved'}</Badge>;
            case '3':
                return <Badge bg="warning" text="dark">{stageText || 'Picked Up'}</Badge>;
            case '4':
                return <Badge bg="success">{stageText || 'Refunded'}</Badge>;
            case '5':
                return <Badge bg="danger">{stageText || 'Denied'}</Badge>;
            default:
                return <Badge bg="secondary">{stageText || 'Pending'}</Badge>;
        }
    };

    return (
        <div className="table-responsive">
            <table className='table table-bordered table-hover mb-0'>
                <thead>
                    <tr>
                        <th style={{ width: '65px' }}>Return ID</th>
                        <th>Order</th>
                        <th>Customer</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {props.returnList && props.returnList.length > 0 ? (
                        props.returnList.map((item, index) => {
                            const amount = Number(item.amount || 0);
                            return (
                                <tr key={item.id || index}>
                                    <td><strong>#{item.id}</strong></td>
                                    <td>
                                        <div className="fw-semibold">{item.order_uuid || `#${item.order_id}`}</div>
                                    </td>
                                    <td>
                                        <div className="fw-bold">{item.user_name || 'Customer'}</div>
                                    </td>
                                    <td>
                                        <strong className="text-danger">
                                            ₹{amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </strong>
                                    </td>
                                    <td>{getReturnStatusBadge(item.status, item.stage_text)}</td>
                                    <td>{item.created_at || 'N/A'}</td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-3 text-muted">No return requests found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default DatatableReturn;

